"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditMenu = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var menu_1 = require("../../components/menu/menu");
var menu_item_1 = require("../../components/menu/menu.item");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var collection_assign_ctrl_1 = require("./collection.assign.ctrl");
var collection_delete_ctrl_1 = require("./collection.delete.ctrl");
var collection_duplicate_ctrl_1 = require("./collection.duplicate.ctrl");
var collection_form_ctrl_1 = require("./collection.form.ctrl");
var collection_form_migrate_ctrl_1 = require("./collection.form.migrate.ctrl");
var collection_insight_process_ctrl_1 = require("./collection.insight.process.ctrl");
var collection_move_department_ctrl_1 = require("./collection.move.department.ctrl");
var collection_move_job_ctrl_1 = require("./collection.move.job.ctrl");
var collection_status_ctrl_1 = require("./collection.status.ctrl");
var CollectionEditMenu = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionEditMenu, _super);
    function CollectionEditMenu() {
        var _this = _super.call(this) || this;
        _this.menu = new menu_1.MenuComponent({
            items: function () { return _this.viewMenuItems(); }
        });
        return _this;
    }
    Object.defineProperty(CollectionEditMenu.prototype, "nodes", {
        get: function () {
            if (!page_state_1.CurrentState.Tag.ready) {
                return spinner_1.Spinner.view(spinner_1.CSS.buttonSize);
            }
            var currentUser = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
            if (page_state_1.CurrentState.CollectionEdit.isDirty ||
                !this.menu.hasUsableItems ||
                services_1.Services.UserProfile.isDepartmentViewer(currentUser) ||
                services_1.Services.UserProfile.isDepartmentDownloader(currentUser)) {
                return image_button_1.ImageButton.view(icons_1.MaterialIcon.MORE_VERT, { disabled: true });
            }
            return (0, mithril_1.m)('div', [
                image_button_1.ImageButton.view(icons_1.MaterialIcon.MORE_VERT, { onclick: this.menu.show }),
                this.menu.view()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @todo Need to go over each of the visible function and add user role checks
     *   EG: at time of writing the `canAssign` function can return true even if the user is a viewer or a downloader
     */
    CollectionEditMenu.prototype.viewMenuItems = function () {
        var currentUser = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
        return [
            {
                visible: collection_assign_ctrl_1.CollectionAssignCtrl.canAssign(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_ASSIGN), icons_1.MaterialIcon.ASSIGN),
                action: function () { return collection_assign_ctrl_1.CollectionAssignCtrl.showAssignModal(); }
            }, {
                visible: collection_move_job_ctrl_1.CollectionMoveToJobCtrl.canMove(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_JOB), icons_1.MaterialIcon.MOVE),
                action: function () { return collection_move_job_ctrl_1.CollectionMoveToJobCtrl.showMoveModal(); }
            }, {
                visible: collection_move_department_ctrl_1.CollectionMoveToDepartmentCtrl.canMove(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_DEPARTMENT), icons_1.MaterialIcon.EXIT_TO_APP),
                action: function () { return collection_move_department_ctrl_1.CollectionMoveToDepartmentCtrl.showMoveModal(); }
            }, {
                visible: collection_duplicate_ctrl_1.CollectionDuplicateCtrl.canDuplicate(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_DUPLICATE), icons_1.MaterialIcon.DUPLICATE),
                action: function () { return collection_duplicate_ctrl_1.CollectionDuplicateCtrl.showDuplicateModal(); }
            }, {
                visible: collection_status_ctrl_1.CollectionSetStatusCtrl.canDisplay(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_STATUS), icons_1.MaterialIcon.STATUS),
                action: function () { return collection_status_ctrl_1.CollectionSetStatusCtrl.showSetStatusModal(); }
            }, {
                visible: collection_form_ctrl_1.CollectionFormCtrl.canDisplay(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM), icons_1.MaterialIcon.FORM_UPDATE),
                action: function () { return collection_form_ctrl_1.CollectionFormCtrl.showUpdateFormModal(); }
            }, {
                visible: collection_form_migrate_ctrl_1.CollectionFormMigrateCtrl.canDisplay(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM), icons_1.MaterialIcon.MOVE_DOWN),
                action: function () { return collection_form_migrate_ctrl_1.CollectionFormMigrateCtrl.showMigrateFormModal(); }
            }, {
                visible: (services_1.Services.UserProfile.isDepartmentAdmin(currentUser) || services_1.Services.UserProfile.isDepartmentDataAdmin(currentUser)) &&
                    services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_REVISION_HISTORY) && page_state_1.CurrentState.Tag.collectionSize === 1,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY), icons_1.MaterialIcon.MANAGE_HISTORY),
                action: function () {
                    var _a, _b;
                    return services_1.Services.Route.go(page_1.IkePageName.collectionHistory, {
                        collectionUuid: (_b = (_a = page_state_1.CurrentState.Tag.collections) === null || _a === void 0 ? void 0 : _a[0].uuid) !== null && _b !== void 0 ? _b : ''
                    });
                }
            }, {
                visible: collection_insight_process_ctrl_1.CollectionInsightProcessCtrl.canTriggerInsightProcessing(currentUser),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_INSIGHT_PROCESS), icons_1.MaterialIcon.SPARKLE),
                action: function () { return collection_insight_process_ctrl_1.CollectionInsightProcessCtrl.showInsightProcessModal(); }
            }, {
                visible: collection_delete_ctrl_1.CollectionDeleteCtrl.canDisplay(),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.COLLECTION_DELETE), icons_1.MaterialIcon.DELETE),
                action: function () { return collection_delete_ctrl_1.CollectionDeleteCtrl.showConfirmModal(); }
            }
        ];
    };
    return CollectionEditMenu;
}(mithril_component_1.IMithrilComponent));
exports.CollectionEditMenu = CollectionEditMenu;
//# sourceMappingURL=collection.edit.menu.js.map